module.exports = __webpack_public_path__ + "img/need_banner_notext.422b0ae0.png";